import { render, staticRenderFns } from "./DispatchMessages.vue?vue&type=template&id=2af6b6bc&"
import script from "./DispatchMessages.vue?vue&type=script&lang=js&"
export * from "./DispatchMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports